import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import CardContent from '@mui/material/CardContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';
import session from '../api/session';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Chip from '@mui/material/Chip';
import InputAdornment from '@mui/material/InputAdornment';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  maxHeight: '85vh',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 3,
  flexGrow: 1
};

function SuperVisorModal(props) {
  
  const isControlled = props.open !== undefined;
  const [openLocal, setOpenLocal] = React.useState(false);
  const open = isControlled ? props.open : openLocal;
  const handleCloseInternal = () => {
    if (isControlled) {
      props.onClose && props.onClose();
    } else {
      setOpenLocal(false);
    }
  };

  
  const [benchMeters, setBenchMeters] = React.useState(props.tetragwnika ?? 0);
  const [benchPosition, setBenchPosition] = React.useState(props.benchPosition ?? "");
  const [isPresent, setIsPresent] = React.useState(true);
  const [IllegalTextOne, setIllegalTextOne] = React.useState('');
  const [IllegalTextTwo, setIllegalTextTwo] = React.useState('');
  const [isIllegal, setIsIllegal] = React.useState(false);
  const [selectedViolation, setSelectedViolation] = React.useState(props.violations ?? []);
  const [benchViolations, setBenchViolations] = React.useState(props.benchViolations ?? []);
  const [cashList, setCashList] = React.useState(0);
  const [proofList, setProofList] = React.useState(0);

  
  const [incidents, setIncidents] = React.useState([]);
  const [selectedIncident, setSelectedIncident] = React.useState(null);
  const [loadingIncidents, setLoadingIncidents] = React.useState(false);
  const [previewHtml, setPreviewHtml] = React.useState(null);

React.useEffect(() => {
  if (!selectedIncident?.id) {
    setPreviewHtml(null);
    return;
  }
  let mounted = true;
  session.get(`api/dimotiki-astynomia/email-preview/${selectedIncident.id}/`)
    .then(resp => {
      if (mounted) setPreviewHtml(resp.data.html);
    })
    .catch(e => {
      console.error('email preview fetch error', e);
      if (mounted) setPreviewHtml(null);
    });
  return () => { mounted = false; };
}, [selectedIncident]);




React.useEffect(() => {
  if (isControlled && props.open) {
    
    getBenchDue();
    fetchIncidentsForBench();
  }
  
}, [isControlled, props.open, props.pagkosID]);


React.useEffect(() => {
  if (props.pagkosID) {
    
    setBenchMeters(props.tetragwnika ?? 0);
    setBenchPosition(props.benchPosition ?? "");
    
    if (isControlled && props.open) {
      getBenchDue();
      fetchIncidentsForBench();
    }
  }
  
}, [props.pagkosID]);


React.useEffect(() => {
  setBenchViolations(props.benchViolations ?? []);
}, [props.benchViolations]);


  
  const [tabIndex, setTabIndex] = React.useState(0);
  const handleTabChange = (_, newValue) => setTabIndex(newValue);

  
  const getBenchDue = async () => {
    try {
      if (!props.benchAfm) return;
      const resp = await session.get(`api/bench/${props.benchAfm}/dept/`);
      setProofList(resp.data.proof_list);
      setCashList(resp.data.cash_list);
    } catch (e) {
      console.error(e);
      console.error('busty ahh error');
    }
  };

  const fetchIncidentsForBench = async () => {
    if (!props.pagkosID) return;
    try {
      setLoadingIncidents(true);
      const resp = await session.get(`api/ParanomosPagkou/?pagkos=${props.pagkosID}`);
      const items = resp.data.results ?? resp.data ?? [];
      setIncidents(items);
      setSelectedIncident(items.length > 0 ? items[0] : null);
    } catch (e) {
      console.error('fetchIncidentsForBench error', e);
    } finally {
      setLoadingIncidents(false);
    }
  };

  const handleOpenInternal = () => {
    getBenchDue();
    fetchIncidentsForBench();
    if (!isControlled) setOpenLocal(true);
  };

  
  const handleOpen = isControlled ? props.onOpen : handleOpenInternal;


    const handleBenchMetersChange = async (e) => {
    const newMeters = e.target.value;
    setBenchMeters(newMeters);
    try {
      await session.put(`api/Pagkoi/${props.pagkosID}/`, { 
        tetragwnika: newMeters 
      });
      
      const resp = await session.get(`api/Pagkoi/${props.pagkosID}/`);
      setBenchMeters(resp.data.tetragwnika);

      if (props.onUpdated) {
        // ενημερώνουμε τον γονέα με τα νεότερα δεδομένα
        props.onUpdated(resp.data);
      }
    } catch (error) {
      console.error('Error updating bench meters:', error);
    }
  };


  const handleChangeViolationSelect = (e) => {
    setSelectedViolation(e.target.value);
  };

  const handleBenchPosition = (e) => {
    
    const arr = e.target.value.split("-").map(x => x !== "").filter(Boolean);
    if (e.target.value.split("-").length > 2) {
      return;
    } else if (arr.length == 1) {
      setBenchMeters(1);
    } else if (arr.length == 0) {
      setBenchMeters(0);
    }
    if (arr.length == 2) {
      try {
        setBenchMeters(Math.abs(eval(e.target.value)) + 1);
      } catch {
        setBenchMeters(0);
      }
    }
    setBenchPosition(e.target.value);
  };

  const updateBenchPosition = () => {
    session.put(`api/Pagkoi/${props.pagkosID}/`, {
      bench_position: benchPosition,
      tetragwnika: benchMeters
    }).catch(console.error);
  };

  const parousiaPagkouPost = () => {
    const user = localStorage.getItem('userselectedd');
    const date = new Date().toISOString().split('T')[0];
    session.post('api/ParousiaPagkou/', {
      parousia: isPresent,
      date: date,
      pagkos: props.pagkosID,
      user: user
    }).catch(console.error);
  };

  const illegalPagkosPost = () => {
    const date = new Date().toISOString().split('T').join(' ');
    const user = localStorage.getItem('userselectedd');
    const payload = {
      paratiriseis: IllegalTextOne,
      paratiriseis2: IllegalTextTwo,
      date: date,
      pagkos: props.pagkosID,
      user: user,
      violations: (props.benchViolations || []).filter(e => selectedViolation.includes(e.title)).map(e => e.id)
    };
    session.post('api/ParanomosPagkou/', payload).then(async (resp) => {
      const created = resp.data;
      
      setIncidents(prev => [created, ...prev]);
      setSelectedIncident(created);
      
      try {
        await session.post('api/dimotiki-astynomia/email/', created);
      } catch (e) {
        console.error('Email send failed', e);
      }
      
      setTabIndex(1);
    }).catch(e => {
      console.error(e);
    });
  };

  const inspectedPagkos = () => {
    const date = new Date().toISOString().split('T').join(' ');
    const user = localStorage.getItem('userselectedd');
    session.post('api/ElegxosPagkou/', {
      date: date,
      user: user,
      pagkos: props.pagkosID
    }).catch(console.error);
  };

  const saveCard = () => {
    updateBenchPosition();
    parousiaPagkouPost();
    inspectedPagkos();
    if (isIllegal) illegalPagkosPost();
    props.endBenchInspection && props.endBenchInspection();
    handleCloseInternal();
  };

  // Render
  return (
    <div>
      {!isControlled && <Button onClick={handleOpenInternal}>Έλεγχος</Button>}

      <Modal open={open} onClose={handleCloseInternal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">Ελεγχος Παγκου</Typography>
          <hr />

          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs value={tabIndex} onChange={handleTabChange}>
              <Tab label="Έλεγχος" value={0} />
              {incidents && incidents.length > 0 && <Tab label="Προηγουμενες Παραβασεις Πωλητη" value={1} />}
            </Tabs>
          </Box>

          {tabIndex === 0 && (
            <Stack spacing={3}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <CardContent sx={{ borderStyle: "solid", borderRadius: "12px", borderColor: "darkcyan", boxShadow: "0 0 6px cyan" }}>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>Στοιχεία κατόχου</Typography>

                    <TextField disabled label="Αρ. Πάγκου" variant="standard" value={props.numberP} sx={{ mb: 1 }} />
                    <TextField disabled label="Oνοματεπώνυμο" variant="standard" value={props.name} sx={{ mb: 1 }} />
                    <TextField disabled label="Έναρξη Άδειας πάγκου" variant="standard" value={props.licenseStart} sx={{ mb: 1 }} />
                    <TextField disabled label="Λήξη Άδειας πάγκου" variant="standard" value={props.licenceEnd} sx={{ mb: 1 }} />

                    <TextField label="Θέση Πάγκου" variant="standard" disabled={!!props.benchPosition} value={benchPosition} onChange={handleBenchPosition} sx={{ mb: 1 }} />
                    <TextField label="Μέτρα" variant="standard" value={benchMeters} onChange={(e) => setBenchMeters(e.target.value)} onBlur={handleBenchMetersChange} sx={{ mb: 1 }} />

                    <TextField disabled label="Barcode" variant="standard" value={props.barcode} sx={{ mb: 1 }} />
                    <TextField disabled label="Qr Code" variant="standard" value={props.qrcode} sx={{ mb: 1 }} />

                    <FormControlLabel control={<Checkbox disabled checked={props.anastoli} inputProps={{ 'aria-label': 'controlled' }} />} label='Αναστολή' />
                    <FormControlLabel control={<Checkbox disabled checked={props.adeiaAllouDimou} inputProps={{ 'aria-label': 'controlled' }} />} label="Άδεια Άλλου Δήμου" />
                    <FormControlLabel control={<Checkbox disabled checked={props.diakopi} inputProps={{ 'aria-label': 'controlled' }} />} label="Διακοπή" />
                  </CardContent>
                </Grid>

                <Grid item xs={4}>
                  <CardContent sx={{ borderStyle: "solid", borderRadius: "12px", borderColor: "darkcyan", display: "flex", flexDirection: "column", gap: 2 }}>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>ΥΠΟΛΟΙΠΟ ΟΦΕΙΛΗΣ</Typography>
                    <TextField label="ΟΦΕΙΛΗ" variant="standard" disabled value={cashList} InputProps={{ endAdornment: <InputAdornment position="end">€</InputAdornment> }} />
                  </CardContent>
                </Grid>

                <Grid item xs={6}>
                  <CardContent sx={{ borderStyle: "solid", borderRadius: "12px", borderColor: "darkcyan", boxShadow: "0 0 6px cyan" }}>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>Παρουσία Πάγκου</Typography>
                    <FormControlLabel control={<Checkbox checked={isPresent} onChange={() => setIsPresent(!isPresent)} inputProps={{ 'aria-label': 'controlled' }} />} label='Παρών' />
                  </CardContent>
                </Grid>

                <Grid item xs={6}>
                  <CardContent sx={{ borderStyle: "solid", borderRadius: "12px", borderColor: "darkcyan", display: "flex", flexDirection: "column", boxShadow: "0 0 6px cyan" }}>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>Παράβαση Πάγκου</Typography>

                    <FormControlLabel control={<Checkbox checked={isIllegal} onChange={() => setIsIllegal(!isIllegal)} inputProps={{ 'aria-label': 'controlled' }} />} label='Ναι' />

                    <FormControl sx={{ m: 1, width: '100%', backgroundColor: !isIllegal ? "#cecece" : '' }}>
                      <InputLabel id="demo-multiple-chip-label">Κατηγορία Παράβασης</InputLabel>
                      <Select disabled={!isIllegal} labelId="demo-multiple-chip-label" id="demo-multiple-chip" multiple value={selectedViolation} onChange={handleChangeViolationSelect} input={<OutlinedInput id="select-multiple-chip" label="Chip" />} renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>{selected.map((value) => <Chip key={value} label={value} />)}</Box>
                      )}>
                        {(props.benchViolations || []).map((e) => <MenuItem key={e.id} value={e.title}>{e.title}</MenuItem>)}
                      </Select>
                    </FormControl>

                    <TextField style={{ backgroundColor: !isIllegal ? "#cecece" : '' }} label="Παρατηρήσεις " variant="standard" multiline disabled={!isIllegal} maxRows={4} onChange={(e) => setIllegalTextOne(e.target.value)} />
                  </CardContent>
                </Grid>
              </Grid>

              <Box sx={{ mt: 1 }}>
                <Button variant="contained" color="success" onClick={saveCard}>Αποθηκευση</Button>
                <Button variant="outlined" color="error" onClick={handleCloseInternal} sx={{ ml: 2 }}>Ακυρο</Button>
              </Box>
            </Stack>
          )}

          {tabIndex === 1 && incidents && (
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Box sx={{ overflow: 'auto', pr: 1 }}>
                    <Typography variant="subtitle2">Παραβάσεις</Typography>
                    {loadingIncidents ? <div>Φόρτωση...</div> : incidents.length === 0 ? <div>Δεν υπάρχει καμία καταχώρηση</div> :
                      incidents.map(it => (
                        <Box key={it.id} sx={{ mb: 1 }}>
                          <Button fullWidth variant={selectedIncident && selectedIncident.id === it.id ? 'contained' : 'outlined'} size="small" onClick={() => setSelectedIncident(it)} sx={{ textTransform: 'none' }}>
                            {it.date ? it.date.split('T')[0].split('-').reverse().join('/') : ''}
                          </Button>
                        </Box>
                      ))
                    }
                  </Box>
                </Grid>

                <Grid item xs={8}>
                  <Box sx={{ minHeight: 200 }}>
                    { selectedIncident ? (
                        previewHtml ? (
                            <div>
                            <Typography variant="h6">Λεπτομέρεια Παράβασης — Προεπισκόπηση Email</Typography>
                            <div style={{ marginTop: 8 }}>
                                <div dangerouslySetInnerHTML={{ __html: previewHtml }} />
                            </div>
                            </div>
                        ) : (
                            <div>
                            <Typography variant="h6">Λεπτομέρεια Παράβασης</Typography>
                            <Typography variant="body2" sx={{ mt: 1 }}>
                                Φόρτωση προεπισκόπησης email...
                            </Typography>
                            <Typography variant="body2" sx={{ mt: 2 }}><strong>Ημ/νία:</strong> {selectedIncident.date}</Typography>
                            <Typography variant="body2"><strong>Παρατηρήσεις:</strong></Typography>
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>{selectedIncident.paratiriseis}</Typography>
                            </div>
                        )
                        ) : (
                        <div>Επιλέξτε μια παράβαση για να δείτε λεπτομέρειες</div>
                        )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}

        </Box>
      </Modal>
    </div>
  );
}

export { SuperVisorModal };
